/**
 * Dialog for user password forgotten.
 *	@module components/passwordforgotten
 */

//
//	Requirements
//
import * as passwordData from '@alias_root/src/data/password';
import {getElementByIdStrict, getUniqueId} from '@alias_root/src/framework/ods/domUtils';
import {UiDialogWait, alertDialog} from '@alias_root/src/framework/UiDialog';
import {TC} from './text';
import {renderForm} from './form';
import './index.scss';

//
//	Types
//

//
//	Constants
//

//
//	Variables
//

//
//	Functions
//

/*
 * userPasswordForgottenEvent
 */
export function userPasswordForgottenEvent(): void {
	$('.loginpaswd_lost').off('click');
	$('.loginpaswd_lost').on('click', () => getData());
}

/*
 * getData
 */
async function getData() {
	const id = getUniqueId();
	const $el = $(`<div id="${id}" class="overwriteuiwidgetdefaults" style="display: none;"></div>`).appendTo('body');

	const formValues = {
		email: '',
	};

	renderForm(getElementByIdStrict(id), formValues);

	const dialog = new UiDialogWait({
		autoClose: false,
		title: TC.dialogTitle,
		okButtonTitle: TC.okButtonTitle,
		width: UiDialogWait.getWithAsPercentage(90, 550),
		onClose: async (ok) => {
			if (ok) {
				// save changes
				const request = await passwordData.passwordForgotten(formValues.email);
				// close dialog
				return Promise.resolve(request);
			}

			// close dialog
			return true;
		},
	});

	dialog.setContainerElement($el[0]);

	const ok = await dialog.openAndWait();
	if (ok) {
		await alertDialog(TC.successMessaage.replace('$1', formValues.email));
	}

	dialog.close();

	return null;
}
